'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)('.js-open-glossary').on('click', function (event) {
    (0, _jquery2.default)('.glossary--pdp').addClass('is-active');
    if ((0, _jquery2.default)(window).width() < 728) {
      _dom2.default.$hoverOverlay.addClass('is-active');
      _dom2.default.$html.addClass('drawer-active');
    }
  });

  (0, _jquery2.default)('.glossary__close').on('click', function (event) {
    (0, _jquery2.default)('.glossary--pdp').removeClass('is-active');
    _dom2.default.$hoverOverlay.removeClass('is-active');
    _dom2.default.$html.removeClass('drawer-active');
  });
};

var init = exports.init = function init() {
  bindUIActions();
};